<template>
    <div class="no-permission-page">
        <div>
            <div class="no-permission-text">
                403
            </div>
            <div class="no-permission-text">
                <v-icon
                    color="red"
                    size="80"
                    class="mr-5">
                    warning
                </v-icon>

                No Permission
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoPermission'
}
</script>

<style lang="scss" scoped>
.no-permission-text{
    font-size: 80px;
    display: flex;
    justify-content: center;
}
.no-permission-page{
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #f7f7f7;
}
</style>
